import React from 'react';
import Navbar from '../../components/Navbar';
import BottomNavbar from '../dashboard/BottomNavbar';

const InfluencerLayout = ({ children, pageTitle = "Influencer Dashboard" }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      <div className="pt-18 pb-20 lg:pb-6">
        {children}
      </div>
      <BottomNavbar />
    </div>
  );
};

export default InfluencerLayout;
